// The Different partitions in the dashboard (ie Announcements, Tasks, Projects, RFIs, Submittals, Invoices, Contact Us)

import { AssignmentProps } from "@/interfaces/assignment_types"
import { AssignmentCard } from "../../Cards/AssignmentCard"

type AssignmentInnerContainerProps = {
    assignments: AssignmentProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}
// This container contains the Tasks per project
export function AssignmentInnerContainer({assignments, isNewCard, markAsSeen}: AssignmentInnerContainerProps) {
    return (
        <div className="overflow-y-auto h-fit max-h-[60vh]">
            {assignments.map((assignment) => (
                <AssignmentCard 
                    assignment={assignment} 
                    key={assignment.id} 
                    isNew={isNewCard('assignment', assignment.id ?? '')} 
                    onView={() => markAsSeen('assignment', assignment.id ?? '')} 
                />
            ))}
        </div>
    )
}
